import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorReset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M10.174 3.953a8.25 8.25 0 0 1 7.655 2.215l.01.01.007.006L21.11 9.25H17a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-1.5 0v4.264l-3.368-3.165a9.75 9.75 0 0 0-16.08 3.648.75.75 0 0 0 1.415.5 8.25 8.25 0 0 1 5.957-5.294Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M13.826 20.047a8.25 8.25 0 0 1-7.666-2.225l-.007-.006-3.262-3.066H7a.75.75 0 0 0 0-1.5H1a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 1.5 0v-4.264l3.368 3.165a9.75 9.75 0 0 0 16.079-3.648.75.75 0 1 0-1.414-.5 8.251 8.251 0 0 1-5.957 5.294Z"
    />
  </svg>
);
export default SvgTwoColorReset;
